import { render, staticRenderFns } from "./UpskillCoursesDetails.vue?vue&type=template&id=7057269f&scoped=true&"
import script from "./UpskillCoursesDetails.vue?vue&type=script&lang=ts&"
export * from "./UpskillCoursesDetails.vue?vue&type=script&lang=ts&"
import style0 from "./UpskillCoursesDetails.vue?vue&type=style&index=0&id=7057269f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7057269f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow})
